<template>
  <div class="page">
    <div class="menu">
      <ProfileNav />
    </div>
    <div class="profile-form">
      <div v-if="$route.name == 'Profile'">
        <h1 id="page-title">Dados Pessoais</h1>
        <el-form
          ref="form"
          :model="user"
          label-width="150px"
          label-position="left"
        >
          <el-form-item label="Username">
            <el-input v-model="username" disabled></el-input>
          </el-form-item>
          <el-form-item label="Nome">
            <el-input v-model="user.name"></el-input>
          </el-form-item>
          <el-form-item label="Data de Nascimento">
            <el-date-picker
              v-model="user.birthDate"
              type="date"
              format="DD/MM/YYYY"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="Sexo">
            <el-radio v-model="user.gender" label="M">Masculino</el-radio>
            <el-radio v-model="user.gender" label="F">Feminino</el-radio>
            <el-radio v-model="user.gender" label="O">Outros</el-radio>
          </el-form-item>
          <el-form-item id="update-profile">
            <el-button type="primary" @click="handleUpdateProfile"
              >Atualizar Perfil</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import ProfileNav from "../../partials/ProfileNav.vue";
import { updateProfile } from "../../services/user";

export default {
  name: "Profile",

  components: {
    ProfileNav,
  },

  data() {
    return {
      username: this.$store.state.user.username,
      user: {
        name: this.$store.state.user.name,
        birthDate: this.$store.state.user.birthDate,
        gender: this.$store.state.user.gender,
        profilePic: this.$store.state.user.profile_picture,
      },
    };
  },

  methods: {
    handleUpdateProfile() {
      updateProfile(this.user)
        .then((response) => {
          if (response.status == 200) {
            this.$store.commit("userStatus", {
              loggedInfo: "LOGGED_IN",
              userData: response.data.user,
            });
            this.$message.success("Perfil atualizado com sucesso!");
          }
        })
        .catch((error) => {
          console.log("update profile error", error);
        });
    },
  },

  mounted() {
    this.emitter.on("image", (profilePic) => {
      this.user.profilePic = profilePic;
    });
    this.emitter.emit("image", this.user.profilePic);
  },
};
</script>
<style scoped>
.page {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 5px;
  width: 80%;
  margin-left: 10%;
  margin-right: 10%;
  margin-top: 2%;
  margin-bottom: 2%;
  overflow: overlay;
  position: relative;
  display: flex;
}

.menu {
  width: 30%;
  float: left;
}

.profile-form {
  width: 50%;
  float: right;
  padding-left: 10%;
  padding-right: 10%;
  padding-bottom: 2%;
}

#page-title {
  text-align: center;
}

#update-profile {
  float: right;
}
</style>
